import { Nav } from 'react-bootstrap'
import styles from '../index.module.scss'
import { HomePageItem } from '../HomePage'

interface FactCardProps {
    fact: HomePageItem
}

export const FactCard = (props: FactCardProps) => {
    const { fact } = props

    return (
        <a
            className={`${styles.card} d-flex flex-column flex-1 gap-2 mb-4`}
            href={fact.link}
            target="_blank"
            rel="noreferrer"
        >
            <a className={`${styles.title}`}>{fact.title}</a>
            <span className={`${styles.factDesc}`}>{fact.description}</span>
            <Nav.Link
                className={`${styles.link} p-0`}
                href={fact.link}
                target="_blank"
                rel="noreferrer"
            >
                {fact.linkName}
            </Nav.Link>
        </a>
    )
}
